module.exports = __webpack_public_path__ + "img/gsjs_bg.5b358eb9.png";